import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TEXT } from '../../constants/text';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: true,
})
export class LoginPageComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);

  protected readonly T = TEXT;

  isChecking = true;

  async ngOnInit() {
    try {
      const isAuth = await this.auth.initializeAuth();
      if (isAuth) {
        void this.router.navigate(['/dashboard']);
        return;
      }
    } catch {
      // not authenticated — fall through to show sign-in UI
    }
    this.isChecking = false;
  }

  onSubmit() {
    this.auth.signIn();
  }
}
